import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSubHeaderLayout from '../layouts/PageSubHeaderLayout/PageSubHeaderLayout';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';
import BalancesListContainer from '@alphapoint/apex-web/lib/components/BalancesList';
import RecentActivityContainer from '@alphapoint/apex-web/lib/components/RecentActivity/RecentActivityContainer';
import { Notifications } from '@alphapoint/apex-web/lib/components/Notifications';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import { PrivacyTermsLinks } from '../components/PrivacyTermsLinks';
import './DashboardPage.css';

const layoutClasses = getBEMClasses('dashboard-page');

const DashboardPage = () => {
  const { t } = useTranslation();

  return (
    <div className={layoutClasses('wrapper')}>
      <div className={layoutClasses('accent-bar')} />
      <div className={layoutClasses('privacy-terms-links')}>
        <PrivacyTermsLinks />
      </div>
      <PageSubHeaderLayout />
      <div className={layoutClasses()}>
        <div className={layoutClasses('notification-row')}>
          <Notifications />
        </div>
        <div className={layoutClasses('market-overview-container')}>
          <div className={layoutClasses('market-overview-container-left')}>
            <RecentActivityContainer filterForSelected={false} />
          </div>
          <div className={layoutClasses('market-overview-container-right')}>
            <div className={layoutClasses('balances-header')}>{t('Balances')}</div>
            <BalancesListContainer />
          </div>
        </div>
      </div>
      <div className={layoutClasses('footer')}>
        <PageFooterLayout />
      </div>
    </div>
  );
};

export default withAuthentication(DashboardPage);
